import { cx } from '@twind/core';
import { useEffect, useState } from 'react';
import { ChatItemFeedback } from 'app/services/chatBot';
import useUiConfig from 'app/hooks/useUiConfig';
import useFeedbackAnalytics, {
  FeedbackSentiment,
  FeedbackType,
  UserQueryType,
} from 'app/hooks/fetch/useFeedbackAnalytics';

import BaseChatItem from './BaseChatItem';
import FeedbackForm from './FeedbackChatItem/FeedbackForm';

interface FeedbackChatItemProps {
  className?: string;
  onFeedback?: (feedbackSentiment: FeedbackSentiment) => void;
  chatItem: ChatItemFeedback;
}

export default function FeedbackChatItem({ className, onFeedback, chatItem }: FeedbackChatItemProps) {
  const { captureFeedbackClicked, captureFeedbackDisplayed } = useFeedbackAnalytics();
  const [selectedFeedback, setSelectedFeedback] = useState<FeedbackSentiment | undefined>(undefined);
  const uiConfig = useUiConfig();
  const feedbackQuestion = uiConfig?.feedback?.feedbackQuestion;

  const handleFeedback = (feedbackSentiment: FeedbackSentiment) => {
    if (selectedFeedback) {
      return;
    }

    setSelectedFeedback(feedbackSentiment);

    if (feedbackSentiment === FeedbackSentiment.POSITIVE) {
      captureFeedbackClicked({
        feedbackType: FeedbackType.Response,
        userQuery: chatItem.queryTyped,
        userQueryType: UserQueryType.AiChat,
        resultType: chatItem.resultType,
        feedbackSentiment: FeedbackSentiment.POSITIVE,
      });
    } else {
      captureFeedbackClicked({
        feedbackType: FeedbackType.Response,
        userQuery: chatItem.queryTyped,
        userQueryType: UserQueryType.AiChat,
        resultType: chatItem.resultType,
        feedbackSentiment: FeedbackSentiment.NEGATIVE,
      });
    }
    onFeedback?.(feedbackSentiment);
  };

  useEffect(() => {
    captureFeedbackDisplayed({
      feedbackType: FeedbackType.Response,
      userQuery: chatItem.queryTyped,
      userQueryType: UserQueryType.AiChat,
      resultType: chatItem.resultType,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <BaseChatItem
      showAvatar={false}
      className={cx('ostro-chat-item-feedback relative', className)}
    >
      <FeedbackForm
        feedbackQuestion={feedbackQuestion}
        onClickFeedback={handleFeedback}
        selected={selectedFeedback}
      />
    </BaseChatItem>
  );
}
